/*
 * Copyright © 2017 TEKTELIC Communications Inc.
 */

export default angular.module('tektelic.api.networkSettings', [])
    .factory('networkSettingsService', NetworkSettingsService)
    .name;

/*@ngInject*/
function NetworkSettingsService($http, $q) {

    var service = {
        getNetworkSettings: getNetworkSettings,
        saveNetworkSettings: saveNetworkSettings,
        createDefaultNetworkSettings: createDefaultNetworkSettings
    }

    return service;

    function getNetworkSettings (entityType, entityId) {
        var deferred = $q.defer();
        $http.get(`/api/networkSettings/${entityType}/${entityId}`, null).then(function success(response) {
            deferred.resolve(response.data);
        }, function fail() {
            deferred.reject();
        });
        return deferred.promise;
    }

    function saveNetworkSettings (networkSettings) {
        var deferred = $q.defer();
        var url = '/api/networkSettings';
        $http.post(url, networkSettings).then(function success(response) {
            deferred.resolve(response.data);
        }, function fail() {
            deferred.reject();
        });
        return deferred.promise;
    }

    function createDefaultNetworkSettings() {
        return {
            rxWindow: 0,
            rxDelay: 0,
            fcntCheck: true,
            rx2DataRate: -1,
            rx1DataRateOffset: 0,
            adrInterval: 0,
            installationMargin: 0
        };
    }

}



// WEBPACK FOOTER //
// ./src/app/api/network-settings.service.js